export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-exame' */ '@/views/web-service/laboratorio/cliente/exame/Index'),
        path: 'laboratorio-cliente-exame',
        redirect: 'laboratorio-cliente-exame/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-exame' */'@/views/web-service/laboratorio/cliente/exame/List.vue'),
                name: 'web-service-laboratorio-cliente-exame-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-exame' */ '@/views/web-service/laboratorio/cliente/exame/Form.vue'),
                name: 'web-service-laboratorio-cliente-exame-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-exame' */ '@/views/web-service/laboratorio/cliente/exame/Form.vue'),
                name: 'web-service-laboratorio-cliente-exame-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]